import {
  FETCH_START,
  FETCH_END,
  ERROR_LOGS_SUCCESS,
  MESSAGE_LOGS_SUCCESS,
} from './ActionTypes';
import axios from '../../../axios.conf';
import { history } from '../../../components/Helpers';
import { toast } from 'react-toastify';
import secureLocalStorage from 'react-secure-storage';

export const fetchStart = () => {
  return {
    type: FETCH_START,
  };
};

export const fetchEnd = () => {
  return {
    type: FETCH_END,
  };
};
export const getErrorLogs = (pagination, limit) => {
  return (dispatch) => {
    getErrorLogsAPI(pagination, limit)
      .then((response) => {
        if (response && response.data) {
          dispatch(getErrorLogsSuccess(response.data));
        }
      })
      .catch((error) => { });
  };
};

const getErrorLogsAPI = (pagination, limit) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  result = axios.get(
    '/file-upload-errors?page=' + pagination + '&limit=' + limit,
    { headers: headers },
  );
  return result;
};

export const getErrorLogsSuccess = (data) => {
  return {
    type: ERROR_LOGS_SUCCESS,
    data,
  };
};
export const getMessageLogs = (type, id, data) => {
  return (dispatch) => {
    dispatch(fetchStart())
    getMessageLogsAPI(type, id, data)
      .then((response) => {
        dispatch(fetchEnd())
        if (type) {
          history.push({ pathname: '/message-logs', logType: 'batchjob', statusType: type });
          dispatch(fetchEnd())
        }
        if (data) {
          history.push('/message-logs')
        }
        dispatch(getMessageLogsSuccess(response.data.response));
      })
      .catch((error) => { dispatch(fetchEnd()) });
  };
};

const getMessageLogsAPI = (type, id, data) => {
  const headers = {
    Authorization: secureLocalStorage.getItem('aTk'),
  };
  var result;
  if (type) {
    result = axios.get(
      '/message-log?' +
      'batch_job_id=' +
      id,
      {
        headers: headers,
      },
    );
  }
  else {
    result = axios.post('/message-log', data, {
      headers: headers,
    });
  }
  return result;
};

export const getMessageLogsSuccess = (data) => {
  return {
    type: MESSAGE_LOGS_SUCCESS,
    data,
  };
};
